"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);
/**
 * zone de contexte en bas à gauche (nom, moyennes, ...)
 */
ngModule.directive("obsCommuneMapContextInfo", function() {
    return {
        restrict : "E",
        require  : "^obsCommuneManager",
        scope    : true,
        replace  : true,
        template : require("./obsCommuneMapContextInfo.html")
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/commune/obsCommuneMapContextInfo.js